import React, { useEffect, useState } from "react";
import { getGoogleAuthStatus, login } from "../services/api";
import apiRoutes from "../services/apiRoutes";
import { appEntryPath } from "../services/appRoutes";

const Login = () => {
    const [formData, setFormData] = useState({ username: "", password: "" });
    const [errorMessage, setErrorMessage] = useState("");
    const [isGoogleAuthEnabled, setIsGoogleAuthEnabled] = useState(false);

    useEffect(() => {
        getGoogleAuthStatus()
            .then(({ data }) => setIsGoogleAuthEnabled(Boolean(data.enabled)))
            .catch(() => setIsGoogleAuthEnabled(false));
    }, []);

    const handleChange = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const form = new FormData();
        form.append("username", formData.username);
        form.append("password", formData.password);

        try {
            const response = await login(form);
            if (response.data?.access_token) {
                localStorage.setItem("access_token", response.data.access_token);
            }
            window.location.href = appEntryPath();
        } catch (err) {
            console.error("Error during login:", err.response?.data || err);
            setErrorMessage(err.response?.data?.detail || "Login failed. Please try again.");
        }
    };

    const handleGoogleLogin = () => {
        if (!isGoogleAuthEnabled) {
            setErrorMessage("Google login is not configured yet. Use username and password.");
            return;
        }

        window.location.href = `${apiRoutes.BASE_URL}${apiRoutes.auth.google}`;
    };

    return (
        <div className="container">
            <form onSubmit={handleSubmit}>
                <h1>Login</h1>
                <div>
                    <input
                        type="text"
                        name="username"
                        placeholder="Username"
                        value={formData.username}
                        onChange={handleChange}
                    />
                </div>
                <div>
                    <input
                        type="password"
                        name="password"
                        placeholder="Password"
                        value={formData.password}
                        onChange={handleChange}
                    />
                </div>
                {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
                <button type="submit">Login</button>
            </form>
            <div>
                <h2> </h2>
                <button onClick={handleGoogleLogin} disabled={!isGoogleAuthEnabled}>
                    Login with Google
                </button>
            </div>
        </div>
    );
};

export default Login;
